import { AppShellNavItem } from './AppShell';

export type TeacherV2NavId = 'overview' | 'reporting-cycles' | 'teach' | 'prepare' | 'plan' | 'assessments' | 'diagnostics' | 'students' | 'goals' | 'coaching' | 'reports' | 'queue' | 'review' | 'daily-completion' | 'archives' | 'pathways';

export const teacherV2NavItems = (activeId: TeacherV2NavId): AppShellNavItem[] => {
  const navRows: AppShellNavItem[] = [
    { id: 'overview', label: 'Student overview', to: '/v2/teacher', group: 'Overview' },
    { id: 'support-groups', label: 'Support groups', to: '/v2/teacher?tab=groups', group: 'Overview' },
    { id: 'daily-completion', label: 'Completion & attention', to: '/v2/teacher/daily-completion', group: 'Overview' },
    { id: 'diagnostics', label: 'Standards diagnostics', to: '/v2/teacher/diagnostics', group: 'Overview' },
    { id: 'reports', label: 'Reports', to: '/v2/teacher/reports', group: 'Overview' },
    { id: 'prepare', label: 'Upcoming preparation', to: '/v2/teacher/prepare', group: 'Teach' },
    { id: 'day-review', label: 'Review the day', to: '/v2/teacher/unit-day-review', group: 'Teach' },
    { id: 'teach', label: 'Teach', to: '/v2/teacher/teach', group: 'Teach' },
    { id: 'pathways', label: 'Learning plans', to: '/v2/teacher/planning', group: 'Learning plans' },
    { id: 'unit-details', label: 'Unit details & assessments', to: '/v2/teacher/pathways', group: 'Learning plans' },
    { id: 'plan', label: 'Library', to: '/v2/teacher/plan', group: 'Library' },
    { id: 'assessments', label: 'Assessment builder', to: '/v2/teacher/assessments', group: 'Library' },
    { id: 'assessment-results', label: 'Assessment results', to: '/v2/teacher/queue?purpose=assessment', group: 'Student work' },
    { id: 'review', label: 'Student work review', to: '/v2/teacher/review', group: 'Student work' },
    { id: 'queue', label: 'Make-up work', to: '/v2/teacher/queue?purpose=makeup', group: 'Student work' },
    { id: 'goals', label: 'Goals & approvals', to: '/v2/teacher/goals', group: 'Coaching' },
    { id: 'coaching', label: 'Check-ins & performance', to: '/v2/teacher/coaching', group: 'Coaching' },
    { id: 'students', label: 'Roster', to: '/v2/teacher/students', group: 'Roster' },
    { id: 'reporting-cycles', label: 'Reporting cycles', to: '/v2/teacher/reporting-cycles', group: 'Class settings' },
    { id: 'archives', label: 'Archived sections', to: '/v2/teacher/section-archives', group: 'Manage classes' },
    { id: 'rollover', label: 'Rollover', to: '/v2/teacher/rollover', group: 'Manage classes' },
  ];

  return navRows.map((row) => ({
    ...row,
    active: row.id === activeId,
  }));
};

type StudentLearningConfig = { projects: boolean; courses: boolean; coaching: boolean; roadmap?: boolean; standards?: boolean };

export const studentV2NavItems = (
  activeId: 'dashboard' | 'daily-plan' | 'coaching' | 'review' | 'work' | 'pathways' | 'standards',
  section?: string | number | null,
  config?: StudentLearningConfig,
): AppShellNavItem[] => {
  const rows: AppShellNavItem[] = [
    { id: 'today', label: 'Today', to: '/v2/student', active: activeId === 'dashboard' },
    { id: 'daily-plan', label: 'Daily plan & wrap-up', to: '/v2/student?tab=today', active: activeId === 'daily-plan' },
    { id: 'work', label: 'Assignments & Lessons', to: '/v2/student?tab=work', active: activeId === 'work' },
    { id: 'pathways', label: config?.roadmap ? 'My learning' : config ? (config.projects && config.courses ? 'My learning' : config.courses ? 'My courses' : 'My projects') : 'My units & projects', to: '/v2/student/units', active: activeId === 'pathways' },
    { id: 'goals', label: 'Goals', to: '/v2/student?tab=goals', active: activeId === 'coaching' },
    { id: 'standards', label: 'My standards', to: '/v2/student/standards', active: activeId === 'standards' },
    { id: 'portfolio', label: 'Portfolio', to: '/v2/student?tab=portfolio', active: activeId === 'review' },
    { id: 'feedback', label: 'My work & feedback', to: '/v2/student/work-review' },
    { id: 'coaching', label: 'Check-ins & self-reviews', to: '/v2/student/coaching' },
    { id: 'help', label: 'Help', to: '/v2/student?tab=help' },
  ];
  return rows.filter(item => !config ||
    (!['goals', 'coaching'].includes(item.id) || config.coaching) && (item.id !== 'standards' || config.standards === true) && (item.id !== 'pathways' || config.projects || config.courses || config.roadmap)).map(item => ({
      ...item,
      to: section ? `${item.to}${item.to.includes('?') ? '&' : '?'}section=${encodeURIComponent(String(section))}` : item.to,
    }));
};
